import axios from "axios";
import { FeedbackServiceURL } from "../Services";
import { HideAwaiting, ShowAwaiting } from "../../util/Awaiting";

export type BugReportDTO = {
  title: string;
  message: string;
  bugSeverity: string;
  bugType: string;
};

export type FeatureRequestDTO = {
  title: string;
  message: string;
};

export async function reportBug(props: BugReportDTO) {
  ShowAwaiting();
  var res = await axios.post(FeedbackServiceURL + "api/bug/save", props, {
    withCredentials: false,
  });
  HideAwaiting();
  return res.data;
}

export async function requestFeature(props: FeatureRequestDTO) {
  ShowAwaiting();
  var res = await axios.post(FeedbackServiceURL + "api/feature/save", props, {
    withCredentials: false,
  });
  HideAwaiting();
  return res.data;
}
